<template>
    <div>
        <div class="mb-1">
            <span class="field">{{ $t('checkIn.currentValue') }}: </span>
            <span>{{ formatNumber(post.kpi_checkin.current_value) }}</span>
        </div>
        <div v-if="post.kpi_checkin.satisfaction" class="mb-1">
            <span class="field">{{ $t('checkIn.howAmIFeeling') }}: </span>
            <span class="mr-1">
                <i
                    :class="['fa fa-lg', smileIconClass(post.kpi_checkin.satisfaction)]"
                    :title="$t(smileStatus(post.kpi_checkin.satisfaction))"
                ></i>
            </span>
        </div>
        <div v-if="post.kpi_checkin.evidence" class="mb-1">
            <span class="field">{{ $t('checkIn.evidences') }}: </span>
            <span>
                <b-link @click="download(post.kpi_checkin.id, evidenceFileName)" :title="evidenceFileName"
                    >{{ evidenceFileName }}
                </b-link>
            </span>
        </div>
        <div v-if="post.kpi_checkin.comments">
            <span class="field">{{ $t('checkIn.generalComments') }}: </span>
            <p class="goal-comment">{{ post.kpi_checkin.comments }}</p>
        </div>

        <div v-if="post.kpi_checkin.difficulties">
            <span class="field">{{ $t('checkIn.difficultiesFound') }}: </span>
            <p class="goal-comment">{{ post.kpi_checkin.difficulties }}</p>
        </div>
    </div>
</template>

<script>
import { downloadEvidenceMixin, formatNumberMixin, smilesClassesTargetMixin } from '@/mixins'

export default {
    name: 'Checkin',
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    mixins: [downloadEvidenceMixin, formatNumberMixin, smilesClassesTargetMixin],
}
</script>

<style scoped>
.goal-comment {
    margin-bottom: 5px;
}
</style>
